import React, {Fragment, useEffect, useRef, useState} from "react";
import {createConnection} from "../services/fetch";
import {getStroke} from "perfect-freehand";
import Opts from "../services/opts";
import Date from "moment";

import {DialogP} from "./dialog";

import {useDom} from "../context/dom";

//import {Store} from "../services/store";
import {Shaders} from "../services/shaders";
import {useTelegramWebApp} from '@telegram-web-app/react';


export default function EsketT(props) {
 const telegram = useTelegramWebApp();
  if (window.Telegram.WebApp.initDataUnsafe.user) {
    window.Telegram.WebApp.setHeaderColor('#000000');
    window.Telegram.WebApp.setBackgroundColor('#000000');
    window.Telegram.WebApp.setBottomBarColor('#000000');
console.log(window.Telegram.WebApp.initDataUnsafe.user);
  }

  const dom = useDom();
  const paper=dom.paper;
  const ws = useRef(null);
  let tms=Date.now();
  const sujetId = 878;
  const objId = 1196;
  const getStories = (r) => {
    // !user && setUser(r);
    if (story && story.length == 0) {
      createConnection().get('story', 'filter=user,eq,' + r.id + '&join=sujet&exclude=sujet.code').then(c => {
          c.records ? setStory(c.records) : setStory(null);

        }
      );
    }

  }
  const teleLogin = async (a) => {
    setUser(a);
    const response = await fetch(process.env.REACT_APP_api+"api/records/users?exclude=password&filter=tgid,eq," + a.id);
    await response.json().then(t => {
        if (t.records.length >= 1) {
          const r = t.records[0];
          setUser(r);
          getStories(r);

          r.photo_url = a.photo_url;
          r.username = a.username;
          localStorage.setItem('userId', r.id);
          document.cookie = 'userId=' + r.id + '; path=/; Expires=Thu, 01 Jan 2026 00:00:01 GMT;';
          // dom.setUser(a.records[0]);


        }

      }
    )

  }
  const [user, setUser] = useState(props.pro);
  const [story, setStory] = useState([]);
  const [sujets, setSujets] = useState([]);
  const [page, setPage] = useState(null);

  const store = window.Telegram && Number(window.Telegram.WebApp.version) >= 8 ? window.Telegram.WebApp.CloudStorage : localStorage;
  // const store = Store();
  const [rec, setRec] = useState(false);
  const [open, setOpen] = useState(false);
  let openP = false;

  const brush = useRef(localStorage.getItem('brush') ? localStorage.getItem('brush') : 'pen');
  const color = useRef(localStorage.getItem('color') ? new paper.Color(localStorage.getItem('color')) : '#666666');
  const size = useRef(localStorage.getItem('size') ? localStorage.getItem('size') : 2);
  const [alpha, setAlpha] = useState(.8);
  const ran = Math.random();
  const [draw, setDraw] = useState(false);
  const [tm, setTm] = useState(Date.now());
  const lines = useRef([]);
  const lns = useRef([]);
  // const [line, setLine] = useState({points: [], d: ''});
  const [press, setPress] = useState('');
  const [sujet, setSujet] = useState({id: 0});
  const [inte, setInte] = useState(0);
  const ck = props.prop;
  const myCan = useRef(null);
  const draww = useRef(false);
  const pp = useRef(false);
  let temp = 0;
  let se = 0;
  const ww = window.innerWidth;
  const hh = window.innerHeight;
  const bx = 50;
  const by = bx * Math.sqrt(3) * .5;
  const numx = Math.ceil(ww / bx);

  const numy = Math.ceil(hh / by);
  const verts = [];
  const tris = [];
  const cols = [];
  const cents = [];
  Array(numx * numy).fill(1).map((a, i) => {
    const ti = Math.floor(i / numx) % 2;
    verts.push(new paper.Point((i % numx) * bx + ti * bx * .5, Math.floor(i / numx) * by));


  })
  Array(numx * numy).fill(1).map((a, i) => {
    const ca = i % 2 == 0;
    const ti = Math.floor(i / numx) % 2;
    let ar,ar1;
    if(ti==0){

   ar = [i-1,i,i-1+numx]
   //   if (ca) {  } else {}
  ar1 = [i,i+numx,i-1+numx]
  }else{

        ar = [i-1,i+numx,i-1+numx]
     ar1 = [i-1,i,i+numx]
    }

 if(i % numx > 0 && Math.floor(i / numx) < numy-1){
ar &&    cents.push([.1, verts[ar[0]].add(verts[ar[1]]).add(verts[ar[2]]).divide(3)]);
   ar1 &&   cents.push([.1, verts[ar1[0]].add(verts[ar1[1]]).add(verts[ar1[2]]).divide(3)]);
   const col = Math.random() < 0.1 ? ck.Color(255, 0, 0, .5) : ck.Color(255, 255, 255, 0);
   (ar && i % numx > 0 && Math.floor(i / numx) < numy) && tris.push(ar);
   (i % numx > 0 && Math.floor(i / numx) < numy) && cols.push(col);
 }
  })
//console.log(cents);

  const mat = [
    1, 0, 0, 0,
    0, 1, 0, 0,
    0, 0, 1, 0,
    0, 0, 0, 1];
  let shader1;
  let bgImage;
  let paperB;
  const surf = useRef(null);

  const line = useRef(null);

  let currentLine = 0;
console.log(store);

  if (store &&  store.getItem('size')) {
    store.getItem('color', (b) => {
      color.current = new paper.Color(b);
    });
    store.getItem('size', (b) => {
      size.current = b;
    });
    store.getItem('brush', (b) => {
      brush.current = b;
    });
  }else{

    color.current = new paper.Color('#d500f9');
    size.current = 20;
    brush.current = 'flo';
  }

  const getSvgPathFromStroke = (stroke) => {
    if (!stroke.length) {
      return '';
    }

    const d = stroke.reduce(
      (acc, [x0, y0], i, arr) => {
        const [x1, y1] = arr[(i + 1) % arr.length];
        acc.push(x0, y0, (x0 + x1) / 2, (y0 + y1) / 2);
        return acc;
      },
      ['M', ...stroke[0], 'Q']
    );

    d.push('Z');
    return d.join(' ');
  }
  const repl = () => {
    temp += 3;

    lines.current.map((a, i) => {

      if (i === currentLine) {

        a.d = getSvgPathFromStroke(getStroke(a.points.filter(t => t.tm < temp), a.opts));
      console.log(a.d);
       // setPress(temp);
        if (a.end < temp) {
          i == lines.current.length - 1 && clearInterval(se);

         // setRec(true);
          currentLine++;
          temp = 0;

//console.log(lines);
        }
      }

    })
    lines.current = lines;
  }
  const replay = () => {

    currentLine = 0;
    lines.current = (lines.current.map(a => a.d = ''));
    setTm(Date.now());
    se = setInterval(repl, 2);
    //setPress(press+1);
  }

  const undo = () => {
    const ln = lines.current.pop();
    const lls = lns.current;
    lls.push(ln);
    lns.current = lls;

    lines.current = lines.current.map(a => {
      a.done = false;
      a.rep = true;
      return a;
    });

    su.clear();
    const im2 = surface.makeImageSnapshot([0, 0, ww, hh]);

    bgImage = im2.makeShaderOptions(
      ck.TileMode.Repeat,  // Tile the image in both X and Y directions
      ck.TileMode.Repeat,
      ck.FilterMode.Linear,
      ck.MipmapMode.Nearest,
      ck.Matrix.identity()
    );
    im2.delete();
    const shh4 = shdFinal.makeShaderWithChildren(new Float32Array([ww, hh, ran]), [bgImage, paperB, paperB], mat);
    paintC.setShader(shh4);

//su.drawRRect(rrb, paintC);
    line.current = lines.current[0];
    surface.requestAnimationFrame(drawFrame);
    // setPress(press + 1);
  }

  const ptMove = (e) => {

    if (draww.current) {
      temp++;
      //console.log(line.current);
      // setPress(press + 1);
      const co = e.width == 0 ? e.pointerType === 'pen' ? 10 : 20 : e.pointerType === 'pen' ? 10 : 1;
      if (line.current) {
       // console.log(e.clientY,e.clientX);
        line.current.points.push({
          x: e.clientX,
          y: e.clientY,
          pressure: brush.current != 'pen' ? 0.01 : e.pressure * co,
          pre: e.pressure * co,
          ttm: 0,
          tm: Date.now() - line.current.startT
        });
        line.current.points.map(a => {
          //a.pressure = a.pressure < 5 ? a.pressure + .05 : 5;
          //  line.done = a.pressure < 5 ? false : true;
          return a;
        });
        //  console.log(brush.current);
        const pts = line.current.points.map(a => [a.x, a.y]);

        if (brush.current == 'flo') {

          //  pts.push([line.current.points[0].x, line.current.points[0].y])

        }
        const lin = new paper.Path(pts);
        lin.closed=true;
        line.current.bounds = lin.strokeBounds;
       // lin.smooth({type: 'continuous'});
        line.current.lin=lin;
        line.current.pots = [];
        if (brush.current == 'flo') {


          //  const dr = getSvgPathFromStroke(getStroke(line.current.points, line.current.opts));

          // line.current.dr = dr;

          //  const amount = 15;
          //  const length = lin.length;
          // console.log(Math.max(lin.strokeBounds.width,lin.strokeBounds.height));


          //  lin.simplify(10);
          // //console.log(lin.exportSVG({asString:true}).match(/d="([^"]+)"/)[1])
          line.current.dr = lin.exportSVG({asString: true}).match(/d="([^"]+)"/)[1];

        } else {
          line.current.dr = getSvgPathFromStroke(getStroke(line.current.points, line.current.opts));
        }

      }
      lines.current.map((line, i) => {
        if (!line.done) {
          line.points.map(a => {
            // a.pressure = a.pressure < 5 ? a.pressure + .05 : 5;
            //  line.done = a.pressure < 5 ? false : true;
            return a;
          });
          line.dr = getSvgPathFromStroke(getStroke(line.points, line.opts));

        }
      })


    }
  }


  const getStrokeC = (pts) => {


    const ln = new paper.Path(pts.map(a => [a.x, a.y]));

    ln.smooth({type: 'continuous'});
    ln.simplify(10);
    ln.segments.map(f => f.point.x);
    return ln.exportSVG({asString: true}).match(/d="([^"]+)"/)[1];
  }
  const handleDown = (e) => {
tms   =Date.now();
    if (ws.current) {

      const lo = JSON.stringify({
        event: 'draw',
        data: JSON.stringify({color: [color.current.red, color.current.green, color.current.blue, alpha]})
      });
      console.log(lo);
      ws.current.send(lo);
    }

    draww.current = true;
    //

   paintC.setColor(new ck.Color4f(color.current.red, color.current.green, color.current.blue, alpha));
    const totSt = lines[0] ? lines[0].start : Date.now();
    const opts = new Opts(size.current, brush.current, e.pointerType == 'mouse');

    line.current = {
      points: [], ran: Math.random(),
      d: '',
      start: Date.now() - totSt,
      startT: Date.now(),
      opts: opts,
      alpha: alpha,
      color: color.current.toCSS(false),
      size: size.current,
      brush: brush.current

    };

    //  setTm(Date.now());
    // surface.requestAnimationFrame(drawFrame);

    surface.requestAnimationFrame(drawFrame);
  }

  const rgbToHsl = (r, g, b) => {
    const max = Math.max(r, g, b), min = Math.min(r, g, b);
    let h, s, l = (max + min) / 2;

    if (max == min) {
      h = s = 0; // achromatic
    } else {
      var d = max - min;
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);

      switch (max) {
        case r:
          h = (g - b) / d + (g < b ? 6 : 0);
          break;
        case g:
          h = (b - r) / d + 2;
          break;
        case b:
          h = (r - g) / d + 4;
          break;
      }

      h /= 6;
    }

    return [h, s, l];
  }


  const hue2rgb = (p, q, t) => {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 1 / 2) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
  }
  const hslToRgb = (h, s, l) => {
    let r, g, b;

    if (s == 0) {
      r = g = b = l; // achromatic
    } else {


      const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
      const p = 2 * l - q;

      r = hue2rgb(p, q, h + 1 / 3);
      g = hue2rgb(p, q, h);
      b = hue2rgb(p, q, h - 1 / 3);
    }

    return [r, g, b];
  }


  const drawFrame = (tt) => {

    const brushC = brush.current;
    let done = 1;
    if (line.current && !line.current.done && line.current.points.length > 1) {
//console.log(line.current.lin);
      line.current.points.map(a => {
        //  a.pressure = a.pressure < 5 ? a.pressure + .05 : 5;

        //   line.current.done = a.pressure < 5 ? false : true;
        //console.log(line.current.done);
        return a;
      });

      if (ck) {
        const firstPath = ck.Path.MakeFromSVGString(line.current.dr);
        //   tt.drawRRect(rrb, paint0);
        if (brush.current == 'flo') {
          line.current.points.map((a,i) => {

            const pa=new ck.Paint();
            pa.setStyle(ck.PaintStyle.Fill);
            const po=[i%ww,Math.floor(i/ww)];

            pa.setColor(new ck.Color4f(a.x/ww,a.y/hh,a.pressure,1)); // Black color
            tt.drawRect4f(po[0],po[1], po[0]+1, po[1]+10,pa);

          });

      //   firstPath.stroke({precision: 0.1, width:44, cap: ck.StrokeCap.Square});

        } else if (brush.current == 'pen') {

/*
          line.current.points.map((a,i) => {
            const b=line.current.points[i-1];
tt.drawCircle(a.x,a.y,20,paint)


          });
*/
          tt.drawPath(firstPath, paint);
        } else {


          tt.drawPath(firstPath, paint);
        }





        const im2 = surface.makeImageSnapshot([0, 0, ww, hh]);
        shader1 = im2.makeShaderOptions(
          ck.TileMode.Repeat,  // Tile the image in both X and Y directions
          ck.TileMode.Repeat,
          ck.FilterMode.Linear,
          ck.MipmapMode.Nearest,
          ck.Matrix.identity()
        );


        im2.delete();
        //console.log(paperB,bgImage,shader1);

      su.clear();

  }


      /*
          const llns = lines.map((line, i) => {
            if (!line.done) {
              line.points.map(a => {
                a.pressure = a.pressure < 5 ? a.pressure + .05 : 5;
                line.done = a.pressure < 5 ? false : true;
                return a;
              });
              line.d = getSvgPathFromStroke(getStroke(line.points, line.opts));
              line.dv = getStrokeC(line.points);

            } else {
              done = 0;
            }
            return line;
          })
      */
      const lns = lines.current.filter(a => !a.done);
      // setLines(llns);
      // cka.surface && cka.surface.drawOnce(()=>{})
      //

        if (shader1) {

          const brushT = brush.current == 'aqua' ? 3 : 0;
          const shh = brush.current == 'flo' ?
            shdSFlo.makeShaderWithChildren(new Float32Array([color.current.red, color.current.green, color.current.blue, 0.8, ww, hh, line.current.ran, line.current.bounds.top, line.current.bounds.bottom + size.current * 2, brushT,line.current.points.length,Date.now()-tms,size.current]), [shader1, bgImage, paperB], mat)

            :
            shdS.makeShaderWithChildren(new Float32Array([color.current.red, color.current.green, color.current.blue, 1, ww, hh, line.current.ran, line.current.bounds.top, line.current.bounds.bottom + size.current * 2, brushT]), [shader1, bgImage, paperB], mat);

          paintB.setShader(shh);
        //  const shh4 = shdFinal.makeShaderWithChildren(new Float32Array([ww, hh, ran]), [shh, paperB, paperB], mat);
       //   paintC.setShader(shh4);
          su.drawRRect(rrb, paintB);
      }
      if (!line.current) {
        // su.drawRRect(rrb, paintB);
        //   su.drawRRect(rrb, paintC)

        const im2 = surface.makeImageSnapshot([0, 0, ww, hh]);
        bgImage = im2.makeShaderOptions(
          ck.TileMode.Repeat,  // Tile the image in both X and Y directions
          ck.TileMode.Repeat,
          ck.FilterMode.Linear,
          ck.MipmapMode.Nearest,
          ck.Matrix.identity()
        );
        im2.delete();
        tt.clear();
        //  su.drawRRect(rrb, paintC);
        //  console.log([color.current.red, color.current.green, color.current.blue],[color.current.hue/360, color.current.saturation, color.current.brightness],hslToRgb(color.current.hue/360, color.current.saturation, color.current.brightness));
        // const shh = shdS.makeShaderWithChildren(new Float32Array([color.current.hue/360, color.current.saturation, color.current.brightness, alpha]), [shader1, bgImage], mat);
        //  paintB.setShader(shh);
      }
      // console.log('draw');
    }
    (line.current && !line.current.done && !line.current.rep) && surface.requestAnimationFrame(drawFrame);
    if (line.current && line.current.rep) {

      line.current.rep = false;
      let m = -1;
      lines.current.map((x, i) => {

        if (x.startT == line.current.startT && i < lines.current.length - 1) {


          m = i;
        } else {
          //
        }

      })
      if (m > -1) {
        line.current = lines.current[m + 1];
console.log('d')
        surface.requestAnimationFrame(drawFrame);
        su.drawRRect(rrb, paintB);

        const im3 = surface.makeImageSnapshot([0, 0, ww, hh]);
        bgImage = im3.makeShaderOptions(
          ck.TileMode.Repeat,  // Tile the image in both X and Y directions
          ck.TileMode.Repeat,
          ck.FilterMode.Linear,
          ck.MipmapMode.Nearest,
          ck.Matrix.identity()
        );
        im3.delete();
        su.clear();
        su.drawRRect(rrb, paintC);

      } else {
        console.log('end');
      }


    }

  }

  const handleUp = (e) => {


    /**/
    //localStorage.getItem('size')
cents.map(o=>{

  if(line.current.lin && line.current.lin.contains(o[1])) o[0]=0.5;

});
    line.current.done = true;

    const lns = lines.current.filter(a => !a.done);


    line.current.d = getSvgPathFromStroke(getStroke(line.current.points, line.current.opts));
    line.current.end = Date.now() - line.current.startT;
    line.current.endT = Date.now();
    lines.current.push(line.current);


    lines.current.map((a, i) => {
      const points = a.points.map(u => {

        return [Math.floor(u.x * 1000) / 1000, Math.floor(u.y * 1000) / 1000, Math.floor(u.pressure * 100) / 100, u.tm]

      })
//console.log(points,JSON.stringify({col:a.color,s:a.size,b:a.brush,p:points}).length);
    })
    line.current = null;
    su.drawRRect(rrb, paintB);

    const im3 = surface.makeImageSnapshot([0, 0, ww, hh]);
    bgImage = im3.makeShaderOptions(
      ck.TileMode.Repeat,  // Tile the image in both X and Y directions
      ck.TileMode.Repeat,
      ck.FilterMode.Linear,
      ck.MipmapMode.Nearest,
      ck.Matrix.identity()
    );
    im3.delete();
    //su.clear();
    //su.drawRRect(rrb, paintC);
  //  console.log('stopH');
    draww.current = false;
  }
  const handleLeave = (e) => {
    setDraw(false);
    draww.current = false;
  }



  const filt1 = new ck.ImageFilter.MakeBlur(3, 3, ck.TileMode.Decal, null);
  const filt0 = new ck.MaskFilter.MakeBlur(ck.BlurStyle.Normal, 5, false);
  const filt2 = new ck.ImageFilter.MakeErode(1, 1, null);
  const filt3 = new ck.ImageFilter.MakeDropShadow(0, 0, 3, 3, ck.Color(0, 0, 0, 1), null);
  const surface = ck.MakeCanvasSurface('foo');
  const su = surface.getCanvas();
  const paint = new ck.Paint();
  const paintBl = new ck.Paint();
  const iimg=new ck.MakeImage({width:100,height:1,colorType:ck.ColorType.RGB_565,
    alphaType:ck.AlphaType.Opaque,colorSpace:ck.ColorSpace.ADOBE_RGB},[]);
  const paintA = new ck.Paint();
  paint.setColor(ck.Color(0, 0, 0, 1));
  paintBl.setColor(ck.Color(0, 0, 0, 1.5));
  paintBl.setStrokeWidth(14);// Black color
  paintBl.setStyle(ck.PaintStyle.Stroke);
  paintBl.setStrokeCap(ck.StrokeCap.Square)
  paintBl.setAntiAlias(true);
  paint.setAntiAlias(true);
  paint.setStyle(ck.PaintStyle.Fill);
  const paint0 = new ck.Paint();
  paint0.setColor(ck.Color(-200, -200, -200, .8)); // Black color
  paint0.setAntiAlias(true);
  paint0.setStyle(ck.PaintStyle.Fill);
  const paintB = new ck.Paint();
  //paintB.setColor(ck.Color(255, 255, 255,0)); // Black color
  paintB.setAntiAlias(true);
  paintB.setStyle(ck.PaintStyle.Fill);
  const paintC = new ck.Paint();
  paintC.setAntiAlias(true);
  paintC.setStyle(ck.PaintStyle.Fill);
  const rrb = ck.LTRBRect(0, 0, ww, hh);
  const paintW = new ck.Paint();
  paintW.setAntiAlias(true);
  paintW.setColor(ck.Color(255, 255, 255,1));
  paintW.setStyle(ck.PaintStyle.Fill);

  paint0.setImageFilter(filt3);
 su.drawRRect(rrb, paintW);
  //
  const im2 = surface.makeImageSnapshot([0, 0, ww, hh]);

  bgImage = im2.makeShaderOptions(
    ck.TileMode.Repeat,  // Tile the image in both X and Y directions
    ck.TileMode.Repeat,
    ck.FilterMode.Linear,
    ck.MipmapMode.Nearest,
    ck.Matrix.identity()
  );
  im2.delete();
  //paint.setMaskFilter(filt0);
  //paintB.setShader(bgImage);
  su.clear();
  fetch(require('../static/normal.jpg'))
    .then((response) => response.arrayBuffer())
    .then((buffer) => {
      // console.log(new Uint8Array(buffer));
      const bgg = ck.MakeImageFromEncoded(new Uint8Array(buffer));

      paperB = bgg.makeShaderOptions(
        ck.TileMode.Repeat,  // Tile the image in both X and Y directions
        ck.TileMode.Repeat,
        ck.FilterMode.Linear,
        ck.MipmapMode.Nearest,
        ck.Matrix.identity()
      );

      paintA.setShader(paperB);
      su.drawRRect(rrb, paintA);
      const im2 = surface.makeImageSnapshot([0, 0, ww, hh]);
      const paperIm = ck.ImageFilter.MakeImage(im2, {filter: ck.FilterMode.Nearest});
      const dispFilter = ck.ImageFilter.MakeDisplacementMap(ck.ColorChannel.Blue, ck.ColorChannel.Red, 5, paperIm, null);
      const filt=new ck.MaskFilter.MakeBlur(ck.BlurStyle.Normal,18.0,true);
      //const pEf=ck.PathEffect.MakeDiscrete(2,3,4);
      const pEf=ck.PathEffect.MakeLine2D(1,[1,0,0,1,2,2])
     paintBl.setMaskFilter(filt);
      paint.setImageFilter(dispFilter);
     paintBl.setImageFilter(dispFilter);
      su.clear();
      /***
       wetmap



       */
      const shdWet = ck.RuntimeEffect.Make(Shaders().shdWet);
      const paintW = new ck.Paint();
      paintW.setAntiAlias(true);
      paintW.setStyle(ck.PaintStyle.Fill);

 const pts=[{"x":238.3368637231504,"y":442.47168902147985,"pressure":3.227},{"x":236.9877164677805,"y":441.37914272076375,"pressure":4.836},{"x":236.82793854415277,"y":441.23211515513134,"pressure":5.535},{"x":236.5538058472554,"y":440.96037315035807,"pressure":6.077},{"x":236.2418205250597,"y":442.38482720763733,"pressure":6.138},{"x":236.01271252983295,"y":443.89016634844876,"pressure":6.168},{"x":235.80990214797137,"y":445.51663389021485,"pressure":6.198},{"x":235.6357800715991,"y":447.0693884248211,"pressure":6.227},{"x":235.4612595465394,"y":448.743271360382,"pressure":6.257},{"x":235.32578699284014,"y":450.28407243436766,"pressure":6.282},{"x":235.20904152744635,"y":451.9193058472554,"pressure":6.308},{"x":235.11899212410506,"y":453.49158436754186,"pressure":6.333},{"x":235.0480682577566,"y":455.05708926014324,"pressure":6.359},{"x":234.99148854415282,"y":456.6927211217184,"pressure":6.385},{"x":234.9548312649165,"y":458.3610257756564,"pressure":6.416},{"x":234.96319868735085,"y":459.97832899761346,"pressure":6.447},{"x":235.01898150358,"y":461.54821682577574,"pressure":6.478},{"x":235.1273595465394,"y":463.13085501193325,"pressure":6.51},{"x":235.29749713603823,"y":464.7413846062053,"pressure":6.541},{"x":235.52461288782823,"y":466.2949360381863,"pressure":6.572},{"x":235.82225405727928,"y":467.8739881861576,"pressure":6.607},{"x":236.17448269689743,"y":469.4458682577566,"pressure":6.641},{"x":236.56655620525066,"y":470.9380585918855,"pressure":6.676},{"x":237.0498744630072,"y":472.50675107398575,"pressure":6.711},{"x":237.58578794749408,"y":473.9841988066827,"pressure":6.745},{"x":238.2157353221957,"y":475.464435680191,"pressure":6.773},{"x":238.920192601432,"y":476.8845068019094,"pressure":6.8},{"x":239.72545739856807,"y":478.26433460620535,"pressure":6.828},{"x":240.6303343675418,"y":479.5596912887829,"pressure":6.855},{"x":241.66510560859192,"y":480.76260787589507,"pressure":6.866},{"x":242.83495095465398,"y":481.830051909308,"pressure":6.877},{"x":244.13827661097855,"y":482.7444916467781,"pressure":6.889},{"x":245.57946551312656,"y":483.50672398568025,"pressure":6.9},{"x":247.04535823389025,"y":484.115155131265,"pressure":6.893},{"x":248.58775310262533,"y":484.5725742243437,"pressure":6.886},{"x":250.17278198090693,"y":484.8196124105013,"pressure":6.879},{"x":251.75621706443917,"y":484.91882613365163,"pressure":6.86},{"x":253.35638699284013,"y":484.80925274463016,"pressure":6.84},{"x":253.67952887828167,"y":484.7793690930788,"pressure":6.834},{"x":254.07200083532226,"y":484.7498838902149,"pressure":6.828},{"x":254.40390859188548,"y":484.73952422434377,"pressure":6.821},{"x":254.8908128878282,"y":484.93675632458235,"pressure":6.799},{"x":255.52315095465397,"y":486.453650477327,"pressure":6.764},{"x":255.84031610978525,"y":488.0052096658712,"pressure":6.737},{"x":256.03555596658714,"y":489.7575869928402,"pressure":6.71},{"x":256.1048860381862,"y":491.2549571599047,"pressure":6.651},{"x":256.0570721957041,"y":491.6952429594272,"pressure":6.699},{"x":255.93036551312653,"y":492.0307367541767,"pressure":6.747},{"x":255.72516443914085,"y":492.2614385441528,"pressure":6.795},{"x":254.23377100238667,"y":492.1510682577566,"pressure":6.954},{"x":252.79816038186163,"y":491.5338712410502,"pressure":6.981},{"x":251.44064570405732,"y":490.68557398568026,"pressure":7.009},{"x":250.1229758949881,"y":489.71973436754183,"pressure":7.036},{"x":248.8814097852029,"y":488.7184328162292,"pressure":7.043},{"x":247.7103690930788,"y":487.68804451074,"pressure":7.051},{"x":246.55407100238665,"y":486.5847400954655,"pressure":7.058},{"x":245.41251551312652,"y":485.40891801909316,"pressure":7.065},{"x":244.26378794749408,"y":484.14145274463016,"pressure":7.072},{"x":243.1525145584726,"y":482.86721384248216,"pressure":7.077},{"x":242.1225247016707,"y":481.641585680191,"pressure":7.082},{"x":241.17302147971364,"y":480.46456825775664,"pressure":7.086},{"x":240.2211275656325,"y":479.22140835322205,"pressure":7.091},{"x":239.3250164677805,"y":477.9360128878282,"pressure":7.096},{"x":238.51457183770884,"y":476.5270983293556,"pressure":7.102},{"x":237.99021336515514,"y":475.1404968973748,"pressure":7.111},{"x":237.60212434367546,"y":473.5714059665872,"pressure":7.121},{"x":237.4212286396182,"y":471.89792147971366,"pressure":7.127},{"x":237.61965608591893,"y":470.35632350835334,"pressure":7.134},{"x":238.17310131264918,"y":468.7856387828163,"pressure":7.121},{"x":238.9413103818616,"y":467.3958497613366,"pressure":7.108},{"x":240.10956193317426,"y":466.3981342482101,"pressure":7.038},{"x":241.5786422434368,"y":465.77934343675423,"pressure":6.983},{"x":243.03616754176616,"y":466.1012899761337,"pressure":6.976},{"x":244.53234236276853,"y":466.6734622911696,"pressure":6.993},{"x":245.88666945107403,"y":467.29105775656336,"pressure":6.996},{"x":247.4358379474941,"y":468.09512720763735,"pressure":6.998},{"x":248.8148688544153,"y":468.7135195704058,"pressure":6.996},{"x":250.36443579952268,"y":469.26337875895,"pressure":6.993},{"x":251.92675310262533,"y":469.7060552505967,"pressure":6.99},{"x":253.4213341288783,"y":470.05310405727937,"pressure":6.978},{"x":255.00636300715996,"y":470.35433126491654,"pressure":6.965},{"x":256.678253699284,"y":470.6101353221958,"pressure":6.953},{"x":258.24296169451077,"y":470.79302326968985,"pressure":6.936},{"x":259.8259983293557,"y":470.9205268496421,"pressure":6.92},{"x":261.427762052506,"y":470.99224761336524,"pressure":6.904},{"x":263.0693706443915,"y":471.0085840095466,"pressure":6.888},{"x":264.6926505966587,"y":470.9934429594273,"pressure":6.866},{"x":266.28485155131267,"y":470.95200429594274,"pressure":6.844},{"x":267.8204727923628,"y":470.87430680190937,"pressure":6.821},{"x":269.433393078759,"y":470.7810698090693,"pressure":6.803},{"x":271.0355552505967,"y":470.73963114558484,"pressure":6.784},{"x":271.4363946300716,"y":470.728474582339,"pressure":6.848},{"x":271.7607318615752,"y":470.6934110978521,"pressure":6.913},{"x":270.5729563245824,"y":470.729669928401,"pressure":6.971},{"x":268.9237772076373,"y":471.0607807875896,"pressure":7.028},{"x":267.5192455847256,"y":471.4006575178998,"pressure":7.035},{"x":265.8413781622912,"y":471.8620610978521,"pressure":7.041},{"x":264.44282326968977,"y":472.2760492840096,"pressure":7.047},{"x":262.9036159904535,"y":472.75339081145586,"pressure":7.054},{"x":261.3022507159905,"y":473.2681865155132,"pressure":7.06},{"x":259.8734137231504,"y":473.74433269689746,"pressure":7.059},{"x":258.3724575178998,"y":474.2619175417662,"pressure":7.058},{"x":256.79978054892604,"y":474.82054260143207,"pressure":7.057},{"x":255.31595763723155,"y":475.3612374701671,"pressure":7.056},{"x":253.87835477326973,"y":475.8955571599046,"pressure":7.054},{"x":252.38975047732703,"y":476.45936205250604,"pressure":7.053},{"x":250.84974630071605,"y":477.05265214797146,"pressure":7.052},{"x":249.26152983293562,"y":477.6734352028641,"pressure":7.051},{"x":247.70080632458237,"y":478.28624928400967,"pressure":7.049},{"x":246.19945167064444,"y":478.8767502386636,"pressure":7.048},{"x":244.75746587112172,"y":479.4453365155132,"pressure":7.046},{"x":243.35851252983298,"y":479.99798484486877,"pressure":7.045},{"x":241.77308520286397,"y":480.6255415274464,"pressure":7.044},{"x":240.2737227923628,"y":481.2212223150359,"pressure":7.042},{"x":238.86002684964205,"y":481.78462875894996,"pressure":7.041},{"x":237.3455233890215,"y":482.38947386634857,"pressure":7.039},{"x":235.8027300715991,"y":483.00308484486885,"pressure":7.038},{"x":234.42927744630077,"y":483.5453735083533,"pressure":7.037},{"x":232.83946718377092,"y":484.1657581145585,"pressure":7.035},{"x":231.4699990453461,"y":484.6897181384249,"pressure":7.034},{"x":231.1368959427208,"y":484.8148310262531,"pressure":7.025},{"x":230.75398675417662,"y":484.95946789976136,"pressure":7.017},{"x":230.4009612171838,"y":485.09454200477336,"pressure":7.009},{"x":230.0770224343676,"y":485.21965489260145,"pressure":7.001},{"x":229.78296730310265,"y":485.3348065632459,"pressure":6.992},{"x":229.4634114558473,"y":485.4623101431982,"pressure":6.984},{"x":229.06815035799525,"y":485.62567410501197,"pressure":6.976},{"x":228.77210298329356,"y":485.75556837708837,"pressure":6.967},{"x":228.47725095465395,"y":485.94961288782827,"pressure":6.959},{"x":229.7431224343676,"y":486.46799463007164,"pressure":6.837},{"x":231.36958997613365,"y":486.6803677804297,"pressure":6.796},{"x":232.94505608591888,"y":486.8277937947495,"pressure":6.754},{"x":234.5527965393795,"y":486.9541020286397,"pressure":6.74},{"x":236.10634797136046,"y":487.07084749403344,"pressure":6.726},{"x":237.82087267303106,"y":487.19795262529846,"pressure":6.713},{"x":239.29672661097857,"y":487.3059322195705,"pressure":6.699},{"x":240.87697410501198,"y":487.4202869928402,"pressure":6.686},{"x":242.5608182577566,"y":487.54101694510746,"pressure":6.672},{"x":244.17971527446306,"y":487.6601531026254,"pressure":6.658},{"x":245.76633794749407,"y":487.78725823389027,"pressure":6.644},{"x":247.3529606205251,"y":487.92512147971365,"pressure":6.63},{"x":248.93958329355615,"y":488.07334439140817,"pressure":6.617},{"x":250.52620596658716,"y":488.23232541766123,"pressure":6.603},{"x":252.1128286396182,"y":488.4016661097853,"pressure":6.589},{"x":253.6994513126492,"y":488.5817649164679,"pressure":6.575},{"x":255.341458353222,"y":488.77859856801916,"pressure":6.566},{"x":256.95557398568025,"y":488.97981515513135,"pressure":6.557},{"x":258.5035471360382,"y":489.1814301909308,"pressure":6.549},{"x":260.06148150357996,"y":489.39340489260155,"pressure":6.54},{"x":261.69233198090694,"y":489.62689582338913,"pressure":6.531},{"x":263.2343284009547,"y":489.8603867541767,"pressure":6.522},{"x":264.8356936754177,"y":490.117386157518,"pressure":6.513},{"x":266.4498093078759,"y":490.384346778043,"pressure":6.496},{"x":267.93642136038187,"y":490.63975238663494,"pressure":6.478},{"x":269.57643615751795,"y":490.937393556086,"pressure":6.46},{"x":269.89001527446305,"y":490.9975593078759,"pressure":6.458},{"x":270.18327350835324,"y":491.0549359188545,"pressure":6.455},{"x":270.57176097852033,"y":491.13382875894996,"pressure":6.453},{"x":270.9570608591886,"y":491.2155107398568,"pressure":6.45},{"x":271.3092894988067,"y":491.29440357995236,"pressure":6.447},{"x":271.62765,"y":491.37010883054904,"pressure":6.445},{"x":271.93166634844874,"y":491.4478063245824,"pressure":6.442},{"x":272.34963902147973,"y":491.56853627684967,"pressure":6.44},{"x":272.6632181384249,"y":491.67970346062054,"pressure":6.437},{"x":272.923405131265,"y":491.8594038186158,"pressure":6.434},{"x":271.6726747016707,"y":492.8399860381862,"pressure":6.48},{"x":270.34066073985684,"y":493.45240167064446,"pressure":6.48},{"x":268.83811073985686,"y":494.0855366348449,"pressure":6.48},{"x":267.40289856801917,"y":494.66328723150366,"pressure":6.48},{"x":265.7800170644392,"y":495.29801599045356,"pressure":6.48},{"x":264.33046073985685,"y":495.8462813842483,"pressure":6.463},{"x":262.8267153937948,"y":496.39454677804304,"pressure":6.446},{"x":261.2906957040573,"y":496.9352416467781,"pressure":6.429},{"x":259.8208184964201,"y":497.43609164677815,"pressure":6.412},{"x":258.3055181384249,"y":497.93694164677817,"pressure":6.396},{"x":256.7447946300716,"y":498.43779164677807,"pressure":6.379},{"x":255.1673362768497,"y":498.93107112171845,"pressure":6.365},{"x":253.634504176611,"y":499.3980529832936,"pressure":6.352},{"x":252.14789212410503,"y":499.83873723150367,"pressure":6.339},{"x":250.58716861575184,"y":500.28739045346066,"pressure":6.325},{"x":249.03879701670647,"y":500.7161212410502,"pressure":6.312},{"x":247.54780202863967,"y":501.1121792362769,"pressure":6.299},{"x":245.9030058472554,"y":501.53094880668266,"pressure":6.292},{"x":244.38372100238666,"y":501.9007091885442,"pressure":6.286},{"x":242.81741921241056,"y":502.25811766109797,"pressure":6.279},{"x":241.28458711217186,"y":502.571696778043,"pressure":6.273},{"x":239.69955823389026,"y":502.8510093078759,"pressure":6.29},{"x":238.12727971360385,"y":503.11159474940337,"pressure":6.307},{"x":237.32121801909315,"y":503.792543556086,"pressure":6.218},{"x":238.65920871121722,"y":504.6472159904535,"pressure":6.181},{"x":240.04023186157522,"y":505.3771739856803,"pressure":6.143},{"x":241.41209069212414,"y":506.0672871121719,"pressure":6.135},{"x":242.88196789976135,"y":506.8119877088306,"pressure":6.126},{"x":244.27653830548928,"y":507.5232186157519,"pressure":6.118},{"x":245.66632732696903,"y":508.2352464200479,"pressure":6.109},{"x":247.18720596658716,"y":509.01740119331754,"pressure":6.101},{"x":248.46343711217187,"y":509.694763961814,"pressure":6.061},{"x":249.80182625298335,"y":510.4561994033413,"pressure":6.022},{"x":251.22628031026255,"y":511.3136609785204,"pressure":5.982},{"x":252.65551575179,"y":512.214951909308,"pressure":5.943},{"x":253.88751909307882,"y":513.020216706444,"pressure":5.904},{"x":255.17251610978522,"y":513.8840534606206,"pressure":5.864},{"x":256.5093114558473,"y":514.8064621718378,"pressure":5.825},{"x":257.8983035799523,"y":515.7870443914082,"pressure":5.785},{"x":259.21916097852034,"y":516.7492979713604,"pressure":5.675},{"x":260.45395346062054,"y":517.7318724343676,"pressure":5.564},{"x":261.6863552505967,"y":518.8005118138425,"pressure":5.453},{"x":262.8259184964201,"y":519.8675573985681,"pressure":5.342},{"x":263.9463562052506,"y":520.9907842482102,"pressure":5.232},{"x":265.0644032219571,"y":522.1857318615753,"pressure":5.121},{"x":266.0959868735084,"y":523.3535849642005,"pressure":5.01},{"x":267.112031026253,"y":524.5652674224344,"pressure":4.899},{"x":268.1260829355609,"y":525.8367171837709,"pressure":4.789},{"x":269.0871411694511,"y":527.0990026252983,"pressure":4.678},{"x":270.010346778043,"y":528.36367875895,"pressure":4.567},{"x":270.93195859188546,"y":529.6781609785204,"pressure":4.456},{"x":271.8523750596659,"y":531.0420508353222,"pressure":4.345},{"x":272.80745656324586,"y":532.4872242243438,"pressure":4.165},{"x":273.69400489260147,"y":533.8355745823391,"pressure":3.985},{"x":274.5132153937948,"y":535.0871019093079,"pressure":3.805},{"x":275.41849081145585,"y":536.4804769689738,"pressure":3.625},{"x":276.29109343675424,"y":537.8371947494035,"pressure":3.445},{"x":277.0947644391408,"y":539.1046600238665,"pressure":3.265},{"x":277.97932052505973,"y":540.5346923627685,"pressure":3.085},{"x":278.78697601431986,"y":541.9324503579953,"pressure":2.905},{"x":279.52769212410504,"y":543.699171837709,"pressure":1.465}];
      const ln = new paper.Path(pts.map(a => [a.x*3-400, a.y*3-1000]));
      ln.smooth({type: 'continuous'});
      ln.simplify(10);
     // ln.segments.map(f => f.point.x);
const svgL = new ck.Path.MakeFromSVGString(ln.exportSVG({asString: true}).match(/d="([^"]+)"/)[1]);


  Array(6).fill(Math.random()).map(s => {
        const gr = (4 + Math.random() * 2) / 20;
        const tsh = ck.Shader.MakeRadialGradient([Math.random() * ww, Math.random() * hh], 15 + Math.random() * ww / 20,
          [ck.Color4f(0, 0, 0, gr), ck.Color4f(0, 0, 0, gr), ck.Color4f(0, 0, 0, 0)],
          [0, .6, 1.0], ck.TileMode.Clamp);
        paintW.setColor(ck.Color4f(0, 0, 0, gr));
      //  paintW.setShader(tsh);
        //   su.drawRRect(rrb, paintW);
        // su.drawCircle(Math.random()*ww,Math.random()*hh,3+Math.random()*ww/10, paintW);

      })


      const paintU = new ck.Paint();
      paintU.setColor(ck.Color(0, 0, 0, 0.3)); // Black color
      paintU.setAntiAlias(true);
      paintU.setStyle(ck.PaintStyle.Stroke);
      paintU.setStrokeWidth(10);
/**/
      const ver = ck.MakeVertices(
        ck.VertexMode.Triangles,
        [0, 0, 100, 0, 400, 400, 400, 350],
        null,
        [ck.Color(256, 0, 0, 0.4), ck.Color(256, 100, 1, 0),  // Red (fully opaque)
          ck.Color(256, 200, 0, 0.4),  // Green (fully opaque)
          // Blue (fully opaque)
          ck.Color(256, 0, 0, 0)],
        [0, 1, 2,
          1, 3, 2], true
      );

  //su.drawVertices(ver, ck.BlendMode.Dst, paintW);
      su.clear();      su.drawPath(svgL,paintBl);

      const im5 = surface.makeImageSnapshot([0, 0, ww, hh]);
    //  su.clear();
      const shWetL = im5.makeShaderOptions(
        ck.TileMode.Repeat,  // Tile the image in both X and Y directions
        ck.TileMode.Repeat,
        ck.FilterMode.Linear,
        ck.MipmapMode.Nearest,
        ck.Matrix.identity()
      );
      const shW = shdWet.makeShaderWithChildren(new Float32Array([Math.random(), Math.random(), ww, hh]), [shWetL, shWetL], mat);
  paintW.setShader(shW);

//su.drawRRect(rrb, paintW);
      //su.drawVertices(vertu, ck.BlendMode.Dst, paint);
      surface.requestAnimationFrame(drawFrame);
      /***
       wetmap end



       */

      // paintB.setShader(bgImage);
      //
      im2.delete();
     // im4.delete();
      im5.delete();
      bgg.delete();
    });


  const shdFinal = ck.RuntimeEffect.Make(Shaders().shdFinalN);
  const shdSFlo = ck.RuntimeEffect.Make(Shaders().shdSFlo);

  const shdS = ck.RuntimeEffect.Make(Shaders().shdS);
  const shdSpen = ck.RuntimeEffect.Make(`

  uniform shader uImage;
    uniform shader uImage1;
      uniform shader paperShader;
uniform float r;
uniform float g;
uniform float b;
uniform float a;

vec4 main(vec2 pos) {
vec4 sum = uImage.eval(pos);
vec4 sum1 = uImage1.eval(pos);
vec4 pap = paperShader.eval(pos);
//vec4 layer1 =vec4(hueToRgb(h,s,b),sum.r*a)*sum.r*a;
vec4 layer2 = sum1*(1-sum.r*a);
float aa=1-a;
vec3 rgb=vec3(r,g,b);
//float r =(sum.a > 0) ? r*a + sum1.r*aa :  sum1.r;
//float g =(sum.a > 0) ? g*a + sum1.g*aa :  sum1.g;
//float b =(sum.a > 0) ? b*a + sum1.b*aa : sum1.b;

return vec4(rgb*sum.a*a + sum1.rgb*(1-sum.a*a) ,sum.a*a+sum1.a);
//return vec4(vec3(sum.r*sum1.r,sum.g*sum1.g,sum.b*sum1.b),1);
//return vec4(vec3(r*(sum.r),g*(sum.r),b*(sum.r)),sum.a) + sum1;//sum.a+sum1.a
}
  `);
  //


//  const filt=new CanvasKit.MaskFilter.MakeBlur(CanvasKit.BlurStyle.Normal,36.0,false);
//
  //setOpenP(false);
  const fub = (e) => {
    brush.current = e.brush ? e.brush : brush.current;
    console.log(e);
    color.current = e.color ? new paper.Color(e.color) : color.current;
    size.current = e.size ? e.size : size.current;
    localStorage.setItem('brush', brush.current);
    localStorage.setItem('size', size.current);
    e.color && localStorage.setItem('color', e.color);
  }
  const toggleFullScreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen();
    } else if (document.exitFullscreen) {
      document.exitFullscreen();
    }
  }
  const dias = (a) => {
    const lns = [];
    lines.current.map((o, i) => {
      const pa = new paper.Path(o.points.map((a) => new paper.Segment(new paper.Point(a.x, a.y))));
      const lineSt = o.points.map((a, i) => {

        return {po:JSON.stringify([a.x, a.y, a.pressure])}
      });


      lns.push({
          start: i,
          line: '[]',
          dots: lineSt,//.replace(/([\d])\.(\d)(\d)(\d)[\d]+/g, '$1.$2$3$4').replace(/\]/g, '}').replace(/\[/g, '{'),
          objet: objId,
          color: o.color,
          width: o.size,
          delta: Math.ceil(pa.length),
          type: o.brush
        }
      )
    })




 console.log(lns);

    const ar1 = lns.map(m => {
      return {po: m.dots}
    });
    const ar2 = lns.map(m => {
      m.totalpoints = m.dots.length;
      delete m.dots;
      return m
    });
    let r = [];
    createConnection().getnue({parent:objId,target:'strokes',data:ar2}, 'POST').then(
        dd => {
          console.log(dd.con[0]);

          dd.con.map((ddd, ig) => {
            if(ar1[ig]){

              const f = ar1[ig]

              if(f.po instanceof Array) {

                f.po.map(y => y.strokes = ddd)
               // console.log(f.po);
               r = r.concat(f.po)
              }
            }
          })

          console.log(r);
      createConnection().getnue({target:'point',data:r}, 'POST').then(ff=>{

})

        })
    /*
     createConnection().getnue({parent:cc,target:'strokes',data:lns} ).then(ccc => {
         console.log(ccc);
       })

      */
  }
  useEffect(() => {

    const p1=new paper.Point(12,14)
    const p2=new paper.Point(140,120)
    const pro=p1.project(p2.normalize(1));
    const pro1=p1.normalize(1).dot(p2.normalize(1));
console.log('length',pro1*p1.length,pro.length,Math.sqrt(Math.abs(pro.length*pro.length - p1.length*p1.length)));



    if (props.loc) {
      const usern = dom.user.id;

      const w = window.innerWidth + ',' + window.innerHeight
      ws.current = new WebSocket("wss://newttry.herokuapp.com?type=super&user=" + usern + "&host=" + props.loc + "&size=" + w);
      ws.current.onerror = (event) => {
        console.log(event);
      }
      ws.current.addEventListener('open', () => {
        console.log('op');
      });
      ws.current.addEventListener('close', () => {
        console.log('clo');
      });
      ws.current.onmessage = function (event) {
        const json = JSON.parse(event.data);
        //console.log(`[message] Data received from server: ${json}`);
        try {

          if ((json.event == "data")) {

            console.log(json.data);
          }
        } catch (err) {
          console.log(err)
          // whatever you wish to do with the err
        }

      };
    }

    paper.setup([100, 100]);
    //  setOpenP(true);
    //   color.current = new paper.Color('#ff0000');

    //setColor(cl);
    //  props.pro && setUser(props.pro);
    //  (props.pro && story && story.length == 0) && getStories(props.pro);


  }, []);

  function actStory(st) {
    story.map(p => p.active = false);
    st.active = true;
    setSujets(st.sujet);
    setSujet({id: 0});
  }
const func=(a)=>{
    //console.log(a)
a=='rep' && replay();
}
  function actSujet(st) {
    setSujet(st);
  }

  return (
    <>
      <div id="saad" className="absolute top-0 left-0 h-full w-full" >

        <div ref={myCan} className="h-screen  lock w-screen"
             onPointerMove={ptMove} onPointerDown={e => handleDown(e)}
             onPointerUp={e => handleUp(e)}

        >

        </div>




        <DialogP
          lines={lines.current} undo={undo} dias={dias}  fu={() => {
        }}
          pr={openP} func={func} size={size.current} color={color.current} brush={brush.current} fub={fub}/>


      </div>


    </>
  );
}
